module.exports = __webpack_public_path__ + "img/79.9b7f4478.png";